import React, { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LiveChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    eventType: '',
    message: ''
  });
  const [isSending, setIsSending] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Please fill in required fields: Name, Email, Message');
      return;
    }

    setIsSending(true);
    
    try {
      await axios.post(`${API}/booking`, formData);
      toast.success('Booking request sent! We will contact you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        country: '',
        eventType: '',
        message: ''
      });
      setTimeout(() => setIsOpen(false), 2000);
    } catch (error) {
      console.error('Error sending booking:', error);
      toast.error('Failed to send booking. Please try again or email directly.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <button className="chat-toggle-button" onClick={toggleChat}>
        {isOpen ? <X /> : <MessageCircle />}
      </button>

      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <h3 className="body-regular" style={{ fontWeight: '700' }}>Book Luka Nozza</h3>
            <button className="chat-close" onClick={toggleChat}>
              <X size={16} />
            </button>
          </div>

          <form className="booking-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="body-small">Name *</label>
              <input
                type="text"
                name="name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="body-small">Email *</label>
              <input
                type="email"
                name="email"
                className="form-input"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="body-small">Phone</label>
              <input
                type="tel"
                name="phone"
                className="form-input"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="body-small">Country</label>
              <input
                type="text"
                name="country"
                className="form-input"
                value={formData.country}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="body-small">Event Type</label>
              <select
                name="eventType"
                className="form-input"
                value={formData.eventType}
                onChange={handleChange}
              >
                <option value="">Select show type</option>
                <option value="Retro Rewind">Retro Rewind</option>
                <option value="Fusion Fantasy">Fusion Fantasy</option>
                <option value="Corporate Event">Corporate Event</option>
                <option value="Private Party">Private Party</option>
                <option value="Wedding">Wedding</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label className="body-small">Message *</label>
              <textarea
                name="message"
                className="form-textarea"
                rows="3"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about your event..."
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn-primary" 
              style={{ width: '100%', minWidth: 'auto' }}
              disabled={isSending}
            >
              {isSending ? 'Sending...' : 'Send Booking Request'}
              <Send size={16} />
            </button>
          </form>
        </div>
      )}
    </>
  );
};

export default LiveChat;